module.exports = __webpack_public_path__ + "img/oauth.2d6e8218.png";